<template>
  <header id="header" class="transparent--fixed container-fluid">
    <!--  padding-sm, padding-md, padding-lg  -->
    <div class="wrap-header--padding-lg">
      <nav class="main-navigation">
        <!--  Header Logo  -->
        <!--  class: height-sm, height-md, height-lg  -->
        <div id="logo" class="height-lg">
          <router-link :to="{ name: 'Home' }" class="navbar-brand">
            <picture id="lightLogo" class="light">
              <source
                srcset="
                  @/assets/img/logos/logo-new-1.png 2x,
                  @/assets/img/logos/logo-new-1.png 1x
                "
                type="image/png"
                alt="cashwyre logo"
              />
              <img
                src="@/assets/img/logos/logo-new-1.png"
                alt="cashwyre logo"
              />
            </picture>
            <picture id="coloredLogo" class="colored">
              <source
                srcset="
                  @/assets/img/logos/logo-new-1.png 2x,
                  @/assets/img/logos/logo-new-1.png 1x
                "
                type="image/png"
                alt="cashwyre logo"
              />
              <img
                src="@/assets/img/logos/logo-new-1.png"
                alt="cashwyre logo"
              />
            </picture>
          </router-link>
        </div>
        <!--  END Header Logo  -->

        <!--  Menu  -->
        <div id="main-menu" aria-expanded="false" role="navigation">
          <div class="menu-holder" data-hidden="lg">
            <ul>
              <!-- <li>
                                <router-link :to="{ name: 'Home' }" exact
                                    >Home</router-link
                                >
                            </li> -->
              <li class="dropdown-parent--shadow--round--icon--bgitems">
                <a href="javascript:void(0)">Services</a>
                <div class="dropdown-inner">
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          name: 'WalletServices',
                        }"
                      >
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="wallet-icon"
                        >
                          <title>wallet services</title>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM21.3333 10.6667H10.6667L10.6113 10.6675C9.65507 10.6968 8.88889 11.4811 8.88889 12.4444V19.5556L8.88973 19.6109C8.91899 20.5671 9.70335 21.3333 10.6667 21.3333H21.3333L21.3887 21.3325C22.3449 21.3032 23.1111 20.5189 23.1111 19.5556V12.4444L23.1103 12.3891C23.081 11.4329 22.2966 10.6667 21.3333 10.6667ZM21.9258 15.4073L21.9259 19.5556L21.9248 19.593C21.9054 19.9029 21.648 20.1481 21.3333 20.1481H10.6667L10.6292 20.147C10.3194 20.1276 10.0741 19.8702 10.0741 19.5556L10.074 15.4073H21.9258ZM21.3333 11.8519L21.3708 11.853C21.6806 11.8724 21.9259 12.1298 21.9259 12.4444L21.9258 14.222H10.074L10.0741 12.4444L10.0752 12.407C10.0946 12.0971 10.352 11.8519 10.6667 11.8519H21.3333Z"
                          ></path>
                        </svg>

                        <span class="service">
                          Wallet Services
                          <span class="service-desc"
                            >Buy, Send, Withdraw, &amp; Receive USD</span
                          >
                        </span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{
                          name: 'PaymentServices',
                        }"
                      >
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="payment-icon"
                        >
                          <title>payment services</title>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM17.479 8.88889C17.0068 8.88889 16.6152 9.28167 16.6152 9.75532V10.6795C16.6152 10.8413 16.4885 10.9683 16.3272 10.9683H15.1755C15.0142 10.9683 14.8875 10.8413 14.8875 10.6795V9.75532C14.8875 9.28167 14.4959 8.88889 14.0237 8.88889C13.5515 8.88889 13.1599 9.28167 13.1599 9.75532V10.6795C13.1599 10.8413 13.0332 10.9683 12.872 10.9683H12.6416C12.1694 10.9683 11.7778 11.3611 11.7778 11.8348V20.1641C11.7778 20.6377 12.1694 21.0305 12.6416 21.0305H12.872C13.0332 21.0305 13.1599 21.1576 13.1599 21.3193V22.2447C13.1599 22.7172 13.54 23.1111 14.0237 23.1111C14.4959 23.1111 14.8875 22.7172 14.8875 22.2447V21.3193C14.8875 21.1576 15.0142 21.0305 15.1755 21.0305H16.3272C16.4885 21.0305 16.6152 21.1576 16.6152 21.3193V22.2447C16.6152 22.7172 16.9953 23.1111 17.479 23.1111C17.9512 23.1111 18.3428 22.7172 18.3428 22.2447V21.0894C18.3428 20.9612 18.4119 20.8572 18.5271 20.811C18.8611 20.6839 19.1721 20.4991 19.437 20.2565C20.6463 19.1706 20.7385 17.3222 19.6662 16.1207C19.6098 16.0514 19.6098 15.9474 19.6662 15.8781C19.9081 15.6124 20.0935 15.3005 20.2202 14.9539C20.7961 13.4406 20.0359 11.7539 18.5271 11.1763C18.4119 11.1416 18.3428 11.0261 18.3428 10.9106V9.75532C18.3428 9.28167 17.9512 8.88889 17.479 8.88889ZM17.479 16.8601C18.147 16.8601 18.6883 17.403 18.6883 18.0731C18.6883 18.7431 18.147 19.2861 17.479 19.2861H13.7934C13.6321 19.2861 13.5054 19.159 13.5054 18.9973V17.1489C13.5054 16.9872 13.6321 16.8601 13.7934 16.8601H17.479ZM17.479 12.7012C18.147 12.7012 18.6883 13.2442 18.6883 13.9142C18.6883 14.5842 18.147 15.1272 17.479 15.1272H13.7934C13.6321 15.1272 13.5054 15.0001 13.5054 14.8384V12.99C13.5054 12.8283 13.6321 12.7012 13.7934 12.7012H17.479Z"
                          ></path>
                        </svg>

                        <span class="service">
                          Payment Services
                          <span class="service-desc"
                            >Buy, Sell, Send, &amp; Receive USDT, USDC, &amp;
                            Bitcoin</span
                          >
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <router-link :to="{ name: 'Pricing' }">Pricing</router-link>
              </li>
              <!-- <li>
                <router-link :to="{ name: 'BecomeLiquidityProvider' }"
                  >Become a Partner</router-link
                >
              </li> -->
              <li>
                <router-link :to="{ name: 'CryptoForCash' }"
                  >Crypto4Cash</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'About' }">About Us</router-link>
              </li>
              <li class="dropdown-parent--shadow--round--icon--bgitems">
                <a href="javascript:void(0)">Support</a>
                <div class="dropdown-inner">
                  <ul>
                    <!-- <li>
                                            <router-link
                                                :to="{
                                                    name: 'About',
                                                }"
                                            >
                                                <svg
                                                    width="27"
                                                    height="27"
                                                    viewBox="0 0 27 27"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    class="about-icon"
                                                >
                                                    <circle
                                                        cx="13.5"
                                                        cy="13.5"
                                                        r="13.5"
                                                    ></circle>
                                                    <title>about</title>
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M7.5 18.1667C7.5 16.3257 8.99238 14.8333 10.8333 14.8333H16.1667C18.0076 14.8333 19.5 16.3257 19.5 18.1667V19.5C19.5 19.8682 19.2015 20.1667 18.8333 20.1667C18.4651 20.1667 18.1667 19.8682 18.1667 19.5V18.1667C18.1667 17.0621 17.2712 16.1667 16.1667 16.1667H10.8333C9.72876 16.1667 8.83333 17.0621 8.83333 18.1667V19.5C8.83333 19.8682 8.53486 20.1667 8.16667 20.1667C7.79848 20.1667 7.5 19.8682 7.5 19.5V18.1667Z"
                                                    ></path>
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M10.1667 10.1667C10.1667 8.32573 11.6591 6.83334 13.5 6.83334C15.3409 6.83334 16.8333 8.32573 16.8333 10.1667C16.8333 12.0076 15.3409 13.5 13.5 13.5C11.6591 13.5 10.1667 12.0076 10.1667 10.1667ZM13.5 8.16668C12.3954 8.16668 11.5 9.06211 11.5 10.1667C11.5 11.2712 12.3954 12.1667 13.5 12.1667C14.6046 12.1667 15.5 11.2712 15.5 10.1667C15.5 9.06211 14.6046 8.16668 13.5 8.16668Z"
                                                    ></path>
                                                </svg>

                                                <span class="service">
                                                    About
                                                    <span class="service-desc"
                                                        >What you need to know
                                                        about Cashwyre</span
                                                    >
                                                </span>
                                            </router-link>
                                        </li> -->
                    <li>
                      <router-link
                        :to="{
                          name: 'Contact',
                        }"
                      >
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="contact-icon"
                        >
                          <title>contact us</title>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM21.3333 10.6667H10.6667L10.6113 10.6675C9.65507 10.6968 8.88889 11.4811 8.88889 12.4444V19.5556L8.88973 19.6109C8.91899 20.5671 9.70335 21.3333 10.6667 21.3333H21.3333L21.3887 21.3325C22.3449 21.3032 23.1111 20.5189 23.1111 19.5556V12.4444L23.1103 12.3891C23.081 11.4329 22.2966 10.6667 21.3333 10.6667ZM21.9258 15.4073L21.9259 19.5556L21.9248 19.593C21.9054 19.9029 21.648 20.1481 21.3333 20.1481H10.6667L10.6292 20.147C10.3194 20.1276 10.0741 19.8702 10.0741 19.5556L10.074 15.4073H21.9258ZM21.3333 11.8519L21.3708 11.853C21.6806 11.8724 21.9259 12.1298 21.9259 12.4444L21.9258 14.222H10.074L10.0741 12.4444L10.0752 12.407C10.0946 12.0971 10.352 11.8519 10.6667 11.8519H21.3333Z"
                          ></path>
                        </svg>

                        <span class="service">
                          Contact Us
                          <span class="service-desc"
                            >Want to make an enquiry? Become a liquidity
                            provider!</span
                          >
                        </span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'FAQs' }">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="faq-icon"
                        >
                          <title>faqs</title>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM13.9259 17.5556H10.8148C10.2421 17.5556 9.77778 18.0199 9.77778 18.5926V21.1852C9.77778 21.7579 10.2421 22.2222 10.8148 22.2222H13.4074C13.9801 22.2222 14.4444 21.7579 14.4444 21.1852V20.1481C14.4444 19.8618 14.2123 19.6296 13.9259 19.6296C13.6396 19.6296 13.4074 19.8618 13.4074 20.1481V21.1852H10.8148V18.5926H13.9259C14.2123 18.5926 14.4444 18.3604 14.4444 18.0741C14.4444 17.7877 14.2123 17.5556 13.9259 17.5556ZM21.1852 17.5556H20.1481C19.8618 17.5556 19.6296 17.7877 19.6296 18.0741C19.6296 18.3604 19.8618 18.5926 20.1481 18.5926H21.1852V21.1852H18.5926V18.0741C18.5926 17.7877 18.3604 17.5556 18.0741 17.5556C17.7877 17.5556 17.5556 17.7877 17.5556 18.0741V21.1852C17.5556 21.7579 18.0198 22.2222 18.5926 22.2222H21.1852C21.7579 22.2222 22.2222 21.7579 22.2222 21.1852V18.5926C22.2222 18.0199 21.7579 17.5556 21.1852 17.5556ZM16 17.5556C15.7136 17.5556 15.4815 17.7877 15.4815 18.0741V21.7037C15.4815 21.9901 15.7136 22.2222 16 22.2222C16.2864 22.2222 16.5185 21.9901 16.5185 21.7037V18.0741C16.5185 17.7877 16.2864 17.5556 16 17.5556ZM16 9.77778C15.7136 9.77778 15.4815 10.0099 15.4815 10.2963V14.963C15.4815 15.2493 15.2493 15.4815 14.963 15.4815H10.2963C10.0099 15.4815 9.77778 15.7136 9.77778 16C9.77778 16.2864 10.0099 16.5185 10.2963 16.5185H14.963C15.8221 16.5185 16.5185 15.8221 16.5185 14.963V10.2963C16.5185 10.0099 16.2864 9.77778 16 9.77778ZM21.7037 15.4815H18.0741C17.7877 15.4815 17.5556 15.7136 17.5556 16C17.5556 16.2864 17.7877 16.5185 18.0741 16.5185H21.7037C21.9901 16.5185 22.2222 16.2864 22.2222 16C22.2222 15.7136 21.9901 15.4815 21.7037 15.4815ZM13.4074 9.77778H10.8148C10.2421 9.77778 9.77778 10.2421 9.77778 10.8148V13.4074C9.77778 13.9801 10.2421 14.4444 10.8148 14.4444H11.8519C12.1382 14.4444 12.3704 14.2123 12.3704 13.9259C12.3704 13.6396 12.1382 13.4074 11.8519 13.4074H10.8148V10.8148H13.4074V13.9259C13.4074 14.2123 13.6396 14.4444 13.9259 14.4444C14.2123 14.4444 14.4444 14.2123 14.4444 13.9259V10.8148C14.4444 10.2421 13.9801 9.77778 13.4074 9.77778ZM21.1852 9.77778H18.5926C18.0198 9.77778 17.5556 10.2421 17.5556 10.8148V11.8519C17.5556 12.1382 17.7877 12.3704 18.0741 12.3704C18.3604 12.3704 18.5926 12.1382 18.5926 11.8519V10.8148H21.1852V13.4074H18.0741C17.7877 13.4074 17.5556 13.6396 17.5556 13.9259C17.5556 14.2123 17.7877 14.4444 18.0741 14.4444H21.1852C21.7579 14.4444 22.2222 13.9801 22.2222 13.4074V10.8148C22.2222 10.2421 21.7579 9.77778 21.1852 9.77778Z"
                          ></path>
                        </svg>

                        <span class="service">
                          FAQs
                          <span class="service-desc"
                            >Some frequently asked questions about
                            Cashwyre</span
                          >
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>

          <div class="cta">
            <!-- target="_blank"
                        rel="noopener noreferrer" -->
            <a
              href="#download-app"
              class="btn--big--round--border text-capitalize"
              >Get started</a
            >
          </div>

          <!-- <div class="cta">
                        <a
                            href="https://cashwyre.io/register"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="
                                btn--medium--round
                                bg_success
                                text-capitalize
                            "
                            >Signup</a
                        >
                    </div> -->

          <div class="menu-button" data-visible="lg">
            <div class="icons">
              <span class="bar bar-1"></span>
              <span class="bar bar-2"></span>
              <span class="bar bar-3"></span>
            </div>
          </div>
        </div>

        <div
          id="mobile-menu"
          data-visible="lg"
          aria-expanded="false"
          role="navigation"
        >
          <!-- class: -bg -->
          <div class="mobile-wrap">
            <!-- class: -dotted, -border -->
            <div class="main-links--border col-12">
              <ul>
                <!-- <li>
                                    <router-link :to="{ name: 'Home' }" exact
                                        >Home</router-link
                                    >
                                </li> -->
                <li class="dropdown-parent--icon" aria-expanded="false">
                  <a href="javascript:void(0)">Services</a>
                  <div class="dropdown-inner">
                    <ul>
                      <li>
                        <router-link
                          :to="{
                            name: 'WalletServices',
                          }"
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="wallet-icon"
                          >
                            <title>wallet services</title>
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM21.3333 10.6667H10.6667L10.6113 10.6675C9.65507 10.6968 8.88889 11.4811 8.88889 12.4444V19.5556L8.88973 19.6109C8.91899 20.5671 9.70335 21.3333 10.6667 21.3333H21.3333L21.3887 21.3325C22.3449 21.3032 23.1111 20.5189 23.1111 19.5556V12.4444L23.1103 12.3891C23.081 11.4329 22.2966 10.6667 21.3333 10.6667ZM21.9258 15.4073L21.9259 19.5556L21.9248 19.593C21.9054 19.9029 21.648 20.1481 21.3333 20.1481H10.6667L10.6292 20.147C10.3194 20.1276 10.0741 19.8702 10.0741 19.5556L10.074 15.4073H21.9258ZM21.3333 11.8519L21.3708 11.853C21.6806 11.8724 21.9259 12.1298 21.9259 12.4444L21.9258 14.222H10.074L10.0741 12.4444L10.0752 12.407C10.0946 12.0971 10.352 11.8519 10.6667 11.8519H21.3333Z"
                            ></path>
                          </svg>

                          <span class="service">
                            Wallet Services
                            <span class="service-desc"
                              >Buy, Send, Withdraw, &amp; Receive USD</span
                            >
                          </span>
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'PaymentServices',
                          }"
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="payment-icon"
                          >
                            <title>payment services</title>
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM17.479 8.88889C17.0068 8.88889 16.6152 9.28167 16.6152 9.75532V10.6795C16.6152 10.8413 16.4885 10.9683 16.3272 10.9683H15.1755C15.0142 10.9683 14.8875 10.8413 14.8875 10.6795V9.75532C14.8875 9.28167 14.4959 8.88889 14.0237 8.88889C13.5515 8.88889 13.1599 9.28167 13.1599 9.75532V10.6795C13.1599 10.8413 13.0332 10.9683 12.872 10.9683H12.6416C12.1694 10.9683 11.7778 11.3611 11.7778 11.8348V20.1641C11.7778 20.6377 12.1694 21.0305 12.6416 21.0305H12.872C13.0332 21.0305 13.1599 21.1576 13.1599 21.3193V22.2447C13.1599 22.7172 13.54 23.1111 14.0237 23.1111C14.4959 23.1111 14.8875 22.7172 14.8875 22.2447V21.3193C14.8875 21.1576 15.0142 21.0305 15.1755 21.0305H16.3272C16.4885 21.0305 16.6152 21.1576 16.6152 21.3193V22.2447C16.6152 22.7172 16.9953 23.1111 17.479 23.1111C17.9512 23.1111 18.3428 22.7172 18.3428 22.2447V21.0894C18.3428 20.9612 18.4119 20.8572 18.5271 20.811C18.8611 20.6839 19.1721 20.4991 19.437 20.2565C20.6463 19.1706 20.7385 17.3222 19.6662 16.1207C19.6098 16.0514 19.6098 15.9474 19.6662 15.8781C19.9081 15.6124 20.0935 15.3005 20.2202 14.9539C20.7961 13.4406 20.0359 11.7539 18.5271 11.1763C18.4119 11.1416 18.3428 11.0261 18.3428 10.9106V9.75532C18.3428 9.28167 17.9512 8.88889 17.479 8.88889ZM17.479 16.8601C18.147 16.8601 18.6883 17.403 18.6883 18.0731C18.6883 18.7431 18.147 19.2861 17.479 19.2861H13.7934C13.6321 19.2861 13.5054 19.159 13.5054 18.9973V17.1489C13.5054 16.9872 13.6321 16.8601 13.7934 16.8601H17.479ZM17.479 12.7012C18.147 12.7012 18.6883 13.2442 18.6883 13.9142C18.6883 14.5842 18.147 15.1272 17.479 15.1272H13.7934C13.6321 15.1272 13.5054 15.0001 13.5054 14.8384V12.99C13.5054 12.8283 13.6321 12.7012 13.7934 12.7012H17.479Z"
                            ></path>
                          </svg>

                          <span class="service">
                            Payment Services
                            <span class="service-desc"
                              >Buy, Sell, Send, &amp; Receive USDT, USDC, &amp;
                              Bitcoin</span
                            >
                          </span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <router-link :to="{ name: 'Pricing' }">Pricing</router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'CryptoForCash',
                    }"
                    >Crypto4Cash</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'BecomeLiquidityProvider',
                    }"
                    >Become a Partner</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'About' }">About Us</router-link>
                </li>

                <!-- <li>
                                    <router-link :to="{ name: 'Testimonials' }"
                                        >Testimonials</router-link
                                    >
                                </li> -->

                <li class="dropdown-parent--icon" aria-expanded="false">
                  <a href="javascript:void(0)">Support</a>
                  <div class="dropdown-inner">
                    <ul>
                      <!-- <li>
                                                <router-link
                                                    :to="{
                                                        name: 'About',
                                                    }"
                                                >
                                                    <svg
                                                        width="27"
                                                        height="27"
                                                        viewBox="0 0 27 27"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        class="about-icon"
                                                    >
                                                        <circle
                                                            cx="13.5"
                                                            cy="13.5"
                                                            r="13.5"
                                                        ></circle>
                                                        <title>about</title>
                                                        <path
                                                            fill-rule="evenodd"
                                                            clip-rule="evenodd"
                                                            d="M7.5 18.1667C7.5 16.3257 8.99238 14.8333 10.8333 14.8333H16.1667C18.0076 14.8333 19.5 16.3257 19.5 18.1667V19.5C19.5 19.8682 19.2015 20.1667 18.8333 20.1667C18.4651 20.1667 18.1667 19.8682 18.1667 19.5V18.1667C18.1667 17.0621 17.2712 16.1667 16.1667 16.1667H10.8333C9.72876 16.1667 8.83333 17.0621 8.83333 18.1667V19.5C8.83333 19.8682 8.53486 20.1667 8.16667 20.1667C7.79848 20.1667 7.5 19.8682 7.5 19.5V18.1667Z"
                                                        ></path>
                                                        <path
                                                            fill-rule="evenodd"
                                                            clip-rule="evenodd"
                                                            d="M10.1667 10.1667C10.1667 8.32573 11.6591 6.83334 13.5 6.83334C15.3409 6.83334 16.8333 8.32573 16.8333 10.1667C16.8333 12.0076 15.3409 13.5 13.5 13.5C11.6591 13.5 10.1667 12.0076 10.1667 10.1667ZM13.5 8.16668C12.3954 8.16668 11.5 9.06211 11.5 10.1667C11.5 11.2712 12.3954 12.1667 13.5 12.1667C14.6046 12.1667 15.5 11.2712 15.5 10.1667C15.5 9.06211 14.6046 8.16668 13.5 8.16668Z"
                                                        ></path>
                                                    </svg>

                                                    <span class="service">
                                                        About
                                                        <span
                                                            class="service-desc"
                                                            >What you need to
                                                            know about
                                                            Cashwyre</span
                                                        >
                                                    </span>
                                                </router-link>
                                            </li> -->
                      <li>
                        <router-link
                          :to="{
                            name: 'Contact',
                          }"
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="contact-icon"
                          >
                            <title>contact us</title>
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM21.3333 10.6667H10.6667L10.6113 10.6675C9.65507 10.6968 8.88889 11.4811 8.88889 12.4444V19.5556L8.88973 19.6109C8.91899 20.5671 9.70335 21.3333 10.6667 21.3333H21.3333L21.3887 21.3325C22.3449 21.3032 23.1111 20.5189 23.1111 19.5556V12.4444L23.1103 12.3891C23.081 11.4329 22.2966 10.6667 21.3333 10.6667ZM21.9258 15.4073L21.9259 19.5556L21.9248 19.593C21.9054 19.9029 21.648 20.1481 21.3333 20.1481H10.6667L10.6292 20.147C10.3194 20.1276 10.0741 19.8702 10.0741 19.5556L10.074 15.4073H21.9258ZM21.3333 11.8519L21.3708 11.853C21.6806 11.8724 21.9259 12.1298 21.9259 12.4444L21.9258 14.222H10.074L10.0741 12.4444L10.0752 12.407C10.0946 12.0971 10.352 11.8519 10.6667 11.8519H21.3333Z"
                            ></path>
                          </svg>

                          <span class="service">
                            Contact Us
                            <span class="service-desc"
                              >Want to make an enquiry? Become a liquidity
                              provider!</span
                            >
                          </span>
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="{ name: 'FAQs' }">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="faq-icon"
                          >
                            <title>faqs</title>
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM13.9259 17.5556H10.8148C10.2421 17.5556 9.77778 18.0199 9.77778 18.5926V21.1852C9.77778 21.7579 10.2421 22.2222 10.8148 22.2222H13.4074C13.9801 22.2222 14.4444 21.7579 14.4444 21.1852V20.1481C14.4444 19.8618 14.2123 19.6296 13.9259 19.6296C13.6396 19.6296 13.4074 19.8618 13.4074 20.1481V21.1852H10.8148V18.5926H13.9259C14.2123 18.5926 14.4444 18.3604 14.4444 18.0741C14.4444 17.7877 14.2123 17.5556 13.9259 17.5556ZM21.1852 17.5556H20.1481C19.8618 17.5556 19.6296 17.7877 19.6296 18.0741C19.6296 18.3604 19.8618 18.5926 20.1481 18.5926H21.1852V21.1852H18.5926V18.0741C18.5926 17.7877 18.3604 17.5556 18.0741 17.5556C17.7877 17.5556 17.5556 17.7877 17.5556 18.0741V21.1852C17.5556 21.7579 18.0198 22.2222 18.5926 22.2222H21.1852C21.7579 22.2222 22.2222 21.7579 22.2222 21.1852V18.5926C22.2222 18.0199 21.7579 17.5556 21.1852 17.5556ZM16 17.5556C15.7136 17.5556 15.4815 17.7877 15.4815 18.0741V21.7037C15.4815 21.9901 15.7136 22.2222 16 22.2222C16.2864 22.2222 16.5185 21.9901 16.5185 21.7037V18.0741C16.5185 17.7877 16.2864 17.5556 16 17.5556ZM16 9.77778C15.7136 9.77778 15.4815 10.0099 15.4815 10.2963V14.963C15.4815 15.2493 15.2493 15.4815 14.963 15.4815H10.2963C10.0099 15.4815 9.77778 15.7136 9.77778 16C9.77778 16.2864 10.0099 16.5185 10.2963 16.5185H14.963C15.8221 16.5185 16.5185 15.8221 16.5185 14.963V10.2963C16.5185 10.0099 16.2864 9.77778 16 9.77778ZM21.7037 15.4815H18.0741C17.7877 15.4815 17.5556 15.7136 17.5556 16C17.5556 16.2864 17.7877 16.5185 18.0741 16.5185H21.7037C21.9901 16.5185 22.2222 16.2864 22.2222 16C22.2222 15.7136 21.9901 15.4815 21.7037 15.4815ZM13.4074 9.77778H10.8148C10.2421 9.77778 9.77778 10.2421 9.77778 10.8148V13.4074C9.77778 13.9801 10.2421 14.4444 10.8148 14.4444H11.8519C12.1382 14.4444 12.3704 14.2123 12.3704 13.9259C12.3704 13.6396 12.1382 13.4074 11.8519 13.4074H10.8148V10.8148H13.4074V13.9259C13.4074 14.2123 13.6396 14.4444 13.9259 14.4444C14.2123 14.4444 14.4444 14.2123 14.4444 13.9259V10.8148C14.4444 10.2421 13.9801 9.77778 13.4074 9.77778ZM21.1852 9.77778H18.5926C18.0198 9.77778 17.5556 10.2421 17.5556 10.8148V11.8519C17.5556 12.1382 17.7877 12.3704 18.0741 12.3704C18.3604 12.3704 18.5926 12.1382 18.5926 11.8519V10.8148H21.1852V13.4074H18.0741C17.7877 13.4074 17.5556 13.6396 17.5556 13.9259C17.5556 14.2123 17.7877 14.4444 18.0741 14.4444H21.1852C21.7579 14.4444 22.2222 13.9801 22.2222 13.4074V10.8148C22.2222 10.2421 21.7579 9.77778 21.1852 9.77778Z"
                            ></path>
                          </svg>

                          <span class="service">
                            FAQs
                            <span class="service-desc"
                              >Some frequently asked questions about
                              Cashwyre</span
                            >
                          </span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>

              <div class="cta d-none shown_mobile_only">
                <a
                  href="#download-app"
                  class="btn--big--round--border text-capitalize"
                  >Get started</a
                >

                <!-- <a
                                    href="https://cashwyre.io/register"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="
                                        btn--medium--round
                                        bg_success
                                        text-capitalize
                                    "
                                    >Signup</a
                                > -->
              </div>
            </div>
          </div>
        </div>
        <!--  END Menu  -->
      </nav>
    </div>
  </header>
</template>

<script>
import $ from "jquery";
import "@/mixins";

export default {
  methods: {
    onScroll() {
      /*-------------------------------------------------*/
      /* =  Menu
            /*-------------------------------------------------*/
      var menuMobile = $("#mobile-menu"),
        mainMenu = $("#main-menu"),
        header = $("#header"),
        headerHeight = header.outerHeight(),
        headerStickySpace = 100;

      mainMenu.on("click", '[class*="menu-button"]', function () {
        $("body").toggleClass("no-scroll");

        // var mainMenuItem = $(e.currentTarget);

        if (menuMobile.attr("aria-expanded") === "true") {
          menuMobile.attr("aria-expanded", "false");
          $(this).parent().attr("aria-expanded", "false");
          menuMobile.find('[class*="mobile-submenu"]').removeClass("active");
        } else {
          menuMobile.attr("aria-expanded", "true");
          $(this).parent().attr("aria-expanded", "true");
        }
      });

      menuMobile.on("click", 'li[class*="dropdown-parent"]', function (e) {
        var menuItem = $(e.currentTarget);

        // fixed submenu mobile menu
        if (menuItem.attr("aria-expanded") === undefined) {
          var idDropdown = menuItem.data("dropdown");
          menuMobile.find("#" + idDropdown).toggleClass("active");
        } else {
          // dropdown mobile menu
          if (menuItem.attr("aria-expanded") === "true") {
            $(this).attr("aria-expanded", "false");
          } else {
            $(this).attr("aria-expanded", "true");
          }
        }
      });

      menuMobile.on("click", "#backSubmenu", function () {
        $(this).parent().removeClass("active");
      });

      /*-------------------------------------------------*/
      /* =  Sticky menu
            /*-------------------------------------------------*/
      $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();

        if (scroll >= headerHeight + headerStickySpace) {
          header.addClass("moove");
        } else {
          header.removeClass("moove");
        }
      });
    },
  },

  mounted() {
    this.onScroll();
  },
};
</script>

<style lang="scss" scoped>
// header
//     nav.main-navigation
//     #main-menu
//     .menu-holder
//     ul
//     li[class*="dropdown-parent"][class*="bg"][class*="items"]
//     [class|="dropdown-inner"]
//     ul
//     li:hover {
//     .service {
//         color: var(--orangeDark);
//     }
// }

header nav.main-navigation #main-menu .menu-holder ul {
  margin-bottom: 0;
}

header
  nav.main-navigation
  #main-menu
  .menu-holder
  ul
  li[class*="dropdown-parent"]
  [class|="dropdown-inner"]
  ul {
  min-width: 350px;
  // background-color: var(--black2) !important;
  background-color: rgba(22, 23, 25, 0.935) !important;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  box-shadow: 0 0.125rem 0.125rem rgb(0 0 0 / 15%);

  li {
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 2px;

    &:hover {
      background: transparent !important;

      // a {
      //     .wallet-icon,
      //     .contact-icon {
      //         fill: var(--black2);
      //     }
      // }

      .service {
        color: var(--orangeDark);
      }

      // .service-desc {
      //     color: var(--black2);
      // }
    }

    a {
      display: flex;
      align-items: center;

      &.active {
        .service {
          color: var(--orangeDark);
        }
      }

      svg {
        min-width: 32px;
        min-height: 32px;
        margin-right: 10px;
      }

      .wallet-icon {
        fill: var(--white);
      }

      .payment-icon {
        fill: var(--orangeDark);
      }

      .about-icon {
        fill: var(--white);

        circle {
          fill: var(--orangeDark);
        }
      }

      .contact-icon {
        fill: var(--white);
      }

      .faq-icon {
        fill: var(--orangeDark);
      }

      .service {
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        color: var(--white);
      }

      .service-desc {
        font-size: 13px;
        color: var(--grey2);
        margin-top: 5px;
        line-height: 18px;
      }
    }
  }
}

header
  nav.main-navigation
  #mobile-menu
  [class|="mobile-wrap"]
  [class*="main-links"]
  > ul
  li
  a {
  &.active {
    color: var(--orangeDark);
  }

  &:hover,
  &.active {
    .service {
      color: var(--orangeDark);
    }
  }
}

@media screen and (min-width: 991px) and (max-width: 1080px) {
  header nav.main-navigation #main-menu .menu-holder + [class|="cta"] {
    margin-left: 3rem;
  }

  [class|="btn"][class*="-big"] {
    padding: 0 30px;
  }
}
</style>
